import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const EditAddonModal = ({ show, handleClose, addon, handleUpdate }) => {
    const [nom, setNom] = useState('');
    const [modules, setModules] = useState([]);

    // Charger les valeurs de l'addon sélectionné lorsque la modale s'ouvre
    useEffect(() => {
        if (addon) {
            setNom(addon.nom);
            setModules(addon.modules || []);
        }
    }, [addon]);

    const handleModuleChange = (index, field, value) => {
        const updatedModules = [...modules];
        updatedModules[index] = {
            ...updatedModules[index],
            [field]: value,
        };
        setModules(updatedModules);
    };

    const handleAddModule = () => {
        setModules([...modules, { nom: '', prix: '' }]); // Prix en chaîne de caractères
    };

    const handleRemoveModule = (index) => {
        const updatedModules = modules.filter((_, i) => i !== index);
        setModules(updatedModules);
    };

    const handleSubmit = () => {
        // Formatage du prix pour avoir deux chiffres après la virgule
        const formattedModules = modules.map(module => ({
            ...module,
            prix: module.prix ? parseFloat(module.prix).toFixed(2) : '0.00', // Assurer le formatage
        }));

        const updatedAddon = {
            ...addon,
            nom,
            modules: formattedModules,
        };
        handleUpdate(updatedAddon);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Modifier l'addon</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formAddonNom">
                        <Form.Label>Nom de l'addon</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={nom} 
                            onChange={(e) => setNom(e.target.value)} 
                            placeholder="Nom de l'addon" 
                        />
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Modules</Form.Label>
                        {modules.map((module, index) => (
                            <div key={index} className="d-flex mb-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Nom du module"
                                    value={module.nom}
                                    onChange={(e) => handleModuleChange(index, 'nom', e.target.value)}
                                    className="mr-2"
                                />
                                <Form.Control
                                    type="number"
                                    placeholder="Prix du module en €"
                                    value={module.prix ? parseFloat(module.prix).toFixed(2) : ''} // Convertir le prix pour l'affichage
                                    onChange={(e) => handleModuleChange(index, 'prix', e.target.value)} // Garder prix comme chaîne
                                    className="mr-2"
                                    min="0"
                                />
                                <Button
                                    variant="danger"
                                    onClick={() => handleRemoveModule(index)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </div>
                        ))}
                        <Button variant="primary" onClick={handleAddModule}>
                            Ajouter un module
                        </Button>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Enregistrer les modifications
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditAddonModal;
